import type { MatchRule } from './matchRule';

// Mental subtraction within 10: the enemy shows "8-3" and is destroyed by
// firing 5. Value is the answer, so matching is identity (see additionRule).
// ASCII hyphen, deliberately: the bundled helvetiker font has no U+2212 glyph
// and TextGeometry silently skips missing characters.
export const subtractionRule: MatchRule = {
  id: 'subtraction',
  label: 'Take Away',
  instructions: 'Subtract in your head and fire the difference.',
  answerFor: (value) => value,
  displayFor: (value) => String(value),
  matches: (input, value) => input === value,
  generate: (rng) => {
    const a = rng.int(0, 10); // 0-9
    const b = rng.int(0, a + 1); // keeps a-b ≥ 0
    return { value: a - b, display: `${a}-${b}` };
  },
};
